module.exports = __webpack_public_path__ + "images/151_320.jpg";